import { PublicKey } from '@solana/web3.js'
import { getCachedSignatureWallet } from '../lib/verify'
import projectConfig from './project-config'

export const isSolcatToken = (tokenSymbol?: string): boolean => {
  return tokenSymbol?.toLowerCase() === 'solcat'
}

export const isSolcatTokenAddress = (tokenAddress?: string): boolean => {
  const solcatProject = projectConfig.SOLCAT
  return tokenAddress === solcatProject.address
}

export const usingV2 = (tokenAddress?: string): boolean => {
  return !tokenAddress || !isSolcatTokenAddress(tokenAddress)
}

export const isCachedWallet = (publicKey: PublicKey): boolean => {
  return publicKey.toBase58() === getCachedSignatureWallet()
}
